import { Navigate } from 'react-router-dom';

import type { FeatureConfig } from '@platform/client/features';

import { ROUTE_CONSTANTS } from './constants/routes';
import i18n from './locales/i18n';
import { MainLayout } from './routes/_layout/main';
import { SecurityFocusesRouteNewPortal } from './routes/security-focuses';
import { FocusIDRouteNewPortal } from './routes/security-focuses/$focusID';
import { FocusSpidrIDRouteNewPortal } from './routes/security-focuses/$focusID/spidrs/$spidrID';
import { SpidrLibraryRouteNewPortal } from './routes/spidr-library';
import { AllSpidrsRouteNewPortal } from './routes/spidr-library/all';
import { ExcludedRouteNewPortal } from './routes/spidr-library/excluded';
import { FavoritesRouteNewPortal } from './routes/spidr-library/favorites';
import { IncludedRouteNewPortal } from './routes/spidr-library/included';
import { SpidrIDRouteNewPortal } from './routes/spidrs/$spidrID';

import '@rtkwlf/c3-core-css';
import '@rtkwlf/c3-recipes-timeline/css';

/**
 * TODO: Review pages to be able to use lazy loading and avoid page reloading.
 */
export default {
  routes: [
    {
      path: 'security-journey',
      element: <MainLayout />,
      children: [
        {
          index: true,
          element: (
            <Navigate to={`./${ROUTE_CONSTANTS.SECURITY_FOCUSES}`} replace />
          ),
        },
        {
          path: ROUTE_CONSTANTS.SECURITY_FOCUSES,
          children: [
            {
              ...SecurityFocusesRouteNewPortal,
              index: true,
            },
            {
              path: ROUTE_CONSTANTS.FOCUS_ID,
              children: [
                {
                  ...FocusIDRouteNewPortal,
                  index: true,
                },
                {
                  path: ROUTE_CONSTANTS.SPIDRS,
                  children: [
                    {
                      index: true,
                      element: <div>404</div>,
                    },
                    {
                      ...FocusSpidrIDRouteNewPortal,
                      path: ROUTE_CONSTANTS.SPIDR_ID,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: ROUTE_CONSTANTS.SPIDR_LIBRARY,
          ...SpidrLibraryRouteNewPortal,
          children: [
            {
              index: true,
              // set the default route to all spidrs
              element: <Navigate to={`./${ROUTE_CONSTANTS.ALL}`} replace />,
            },
            {
              ...AllSpidrsRouteNewPortal,
              path: ROUTE_CONSTANTS.ALL,
            },
            {
              ...IncludedRouteNewPortal,
              path: ROUTE_CONSTANTS.INCLUDED,
            },
            {
              ...ExcludedRouteNewPortal,
              path: ROUTE_CONSTANTS.EXCLUDED,
            },
            {
              ...FavoritesRouteNewPortal,
              path: ROUTE_CONSTANTS.FAVORITES,
            },
          ],
        },
        {
          path: ROUTE_CONSTANTS.SPIDRS,
          children: [
            {
              ...SpidrIDRouteNewPortal,
              path: `${ROUTE_CONSTANTS.SPIDR_ID}`,
            },
          ],
        },
      ],
    },
  ],
  navigation: () => ({
    securityJourney: {
      securityFocus: {
        title: i18n.t('navMenu:securityFocuses'),
        segment: '/security-journey/security-focuses',
      },
      spidrLibrary: {
        title: i18n.t('navMenu:spidrLibrary'),
        segment: '/security-journey/spidr-library',
      },
    },
  }),
} satisfies FeatureConfig;
